module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-detail-box",
    attrs: {
      "name": ("订单编号：" + _vm.orderId),
      "backRoute": 'orderList',
      "param": _vm.param
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.pageLoading),
            expression: "pageLoading"
          }],
          staticClass: "detail-content",
          class: {
            'detail-content-verify': _vm.detailType == 2
          }
        }, [(_vm.processDetail) ? [_c('div', {
          staticClass: "detail-content-wrapper"
        }, [_c('el-row', {
          staticClass: "content-item",
          attrs: {
            "gutter": 20
          }
        }, [_c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("用户类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.userid ? '个人用户' : '企业用户'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companyname || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("公司管理员：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companymanagername || '-'))])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.type == 1 ? '试用订单' : '正式订单'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("生效日期：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.effectivetime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单金额：")]), _vm._v(" "), _c('span', {
          staticClass: "value color-red"
        }, [_vm._v(_vm._s(_vm.processDetail.price ? _vm.processDetail.price.toLocaleString() : 0) + " 元")])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作人：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.adminusername || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作时间：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.intime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单状态：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_c('span', {
          staticClass: "myTag",
          class: _vm.processDetail.stateverify == 1 ? 'warning' : 'primary'
        }, [_vm._v(_vm._s(_vm.processDetail.stateverify == 1 ? "申请中" : '审核通过'))])])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 24
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("审核意见：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.comments || '-'))])])])], 1), _vm._v(" "), _c('section', {
          staticClass: "detail-bd"
        }, [_c('header', {
          staticClass: "title"
        }, [_vm._v("产品清单（" + _vm._s(_vm.processDetail.auProList.length) + "）")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.processDetail.auProList
          },
          on: {
            "renew": _vm.handleRenewOrder
          }
        })], 1), _vm._v(" "), (_vm.isShowComment) ? _c('footer', {
          staticClass: "comments-box"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("请输入审核意见：")]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          on: {
            "change": _vm.handerChangeComments
          },
          model: {
            value: (_vm.comments),
            callback: function($$v) {
              _vm.comments = $$v
            },
            expression: "comments"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowError),
            expression: "isShowError"
          }],
          staticClass: "status-text color-red"
        }, [_vm._v("审核意见不能为空")])], 1) : _vm._e()], 1), _vm._v(" "), _c('footer', {
          staticClass: "detail-ft"
        }, [(_vm.isShowComment) ? [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(1)
            }
          }
        }, [_vm._v("提 交")])] : [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = true
            }
          }
        }, [_vm._v("审核不通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(2)
            }
          }
        }, [_vm._v("审核通过")])]], 2)] : _vm._e()], 2), _vm._v(" "), (_vm.visibleRenew) ? _c('ModalFormOrder', {
          attrs: {
            "visible": _vm.visibleRenew,
            "productInfo": _vm.productInfo
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleRenew = $event
            },
            "getDetail": function($event) {
              return _vm.getDetail(_vm.token, _vm.checkCode)
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56c3f258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/orderList/OrderDetail.vue
// module id = 1797
// module chunks = 9